import React from 'react';
import {Link} from "react-router-dom";
import {useAuth} from "context/AuthContext";

function NotAuthorised() {
  const {user} = useAuth();

  return (
    <div className="bg-white min-h-full px-4 py-16 sm:px-6 sm:py-24 md:grid md:place-items-center lg:px-8">
      <div className="max-w-max mx-auto">
        <main className="sm:flex">
          <p className="text-4xl font-extrabold text-brand sm:text-5xl">403</p>
          <div className="sm:ml-6">
            <div className="sm:border-l sm:border-gray-200 sm:pl-6">
              <h1 className="text-4xl font-extrabold text-gray-900 tracking-tight sm:text-5xl">Not authorised</h1>
              <p className="mt-1 text-base text-gray-500">You do not have permission to view this. If you think this is a mistake, please contact your administrator.</p>
            </div>
            <div className="mt-10 flex space-x-3 sm:border-l sm:border-transparent sm:pl-6">
              <Link
                to="/"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-brand hover:bg-brand/80 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand"
              >
                {user ? 'View Dashboard' : 'Login'}
              </Link>
              <a
                href="mailto:support@n-gage.io"
                className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-brand bg-brand/20 hover:bg-brand/10 focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-brand"
              >
                Contact support
              </a>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

export default NotAuthorised;